fragment QuoteTemplateFragment on Quote {
    id
    creatorUser {
        id
        name
    }
    createdTime
    modifiedTime
    headerLeftColumn
    headerRightColumn
    body
    footer
    isSkuShown
    isTermShown
    isDiscountShown
    logo
}
